import styled from "styled-components";

export const ContainerCardLineSelected = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  padding-left: 20px;
  border-bottom: 1px solid #e2e8f0;
`;

export const ContainerFlexColumnCardLine = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerFlexRowCardLine = styled.div`
  display: flex;
`;

export const ContainerTypes = styled.div``;

export const InputDate = styled.input`
  width: 150px;
  height: 30px;
  font-size: 14px;
  color: #475569;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
  resize: none;
`;

export const TextArea = styled.textarea`
  width: 80%;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  padding: 8px;
  resize: none;

  &:focus {
    outline: none;
  }
`;
